// Premium service for handling payments and premium status
import axios from 'axios';
import getApiUrl from '../utils/apiUrl.js';

export const premiumApi = {
  // Process a payment for premium subscription
  processPremium: async (paymentData) => {
    try {
      // Add additional data needed for the API
      const enhancedData = {
        ...paymentData,
        userId: localStorage.getItem('userId') || undefined,
        timestamp: new Date().toISOString()
      };
      
      const response = await axios.post(getApiUrl('/premium/process'), enhancedData);
      return response.data;
    } catch (error) {
      console.error('Error processing premium payment:', error);
      throw error;
    }
  },
  
  // Verify premium status for a user
  verifyPremiumStatus: async (userId) => {
    try {
      const response = await axios.get(getApiUrl(`/premium/status/${userId}`));
      return response.data;
    } catch (error) {
      console.error('Error verifying premium status:', error);
      throw error;
    }
  },
  
  // Store premium status in localStorage
  storePremiumStatus: (planDetails) => {
    const now = new Date();
    let expiryDate;
    let badgeInfo = {};
    
    switch (planDetails.planId) {
      case '30min':
        expiryDate = new Date(now.getTime() + 30 * 60 * 1000);
        badgeInfo = {
          name: 'Bronze',
          tier: 'bronze',
          color: '#CD7F32'
        };
        break;
      case '1hour':
        expiryDate = new Date(now.getTime() + 60 * 60 * 1000);
        badgeInfo = {
          name: 'Gold',
          tier: 'gold',
          color: '#FFD700'
        };
        break;
      case '24hour':
        expiryDate = new Date(now.getTime() + 24 * 60 * 60 * 1000);
        badgeInfo = {
          name: 'Arcane',
          tier: 'arcane',
          color: '#8B5CF6'
        };
        break;
      default:
        expiryDate = new Date(now.getTime() + 30 * 60 * 1000);
        badgeInfo = {
          name: 'Bronze',
          tier: 'bronze',
          color: '#CD7F32'
        };
    }
    
    const premiumData = {
      isActive: true,
      planId: planDetails.planId,
      purchaseDate: now.toISOString(),
      expiry: expiryDate.toISOString(),
      features: planDetails.features,
      badge: badgeInfo
    };
    
    localStorage.setItem('voodoPremium', JSON.stringify(premiumData));
    return premiumData;
  },
  
  // Check premium status from localStorage
  getPremiumStatus: () => {
    const premiumData = localStorage.getItem('voodoPremium');
    
    if (!premiumData) {
      return { isActive: false };
    }
    
    const { isActive, expiry } = JSON.parse(premiumData);
    const now = new Date();
    const expiryDate = new Date(expiry);
    
    if (isActive && expiryDate > now) {
      return JSON.parse(premiumData);
    } else {
      // Premium expired
      localStorage.removeItem('voodoPremium');
      return { isActive: false };
    }
  },
  
  // Clear premium status (used for testing)
  clearPremiumStatus: () => {
    localStorage.removeItem('voodoPremium');
  },

  // Get user's current badge information
  getUserBadge: () => {
    const premiumData = localStorage.getItem('voodoPremium');
    
    if (!premiumData) {
      return null;
    }
    
    const { isActive, expiry, badge } = JSON.parse(premiumData);
    const now = new Date();
    const expiryDate = new Date(expiry);
    
    if (isActive && expiryDate > now && badge) {
      return badge;
    }
    
    return null;
  },

  // Check if user has specific badge tier
  hasBadgeTier: (tier) => {
    const badge = premiumApi.getUserBadge();
    return badge && badge.tier === tier;
  }
};
